import { ReactElement } from 'react';
import { Stack, SxProps } from '@mui/material';
import ProfileMenu from './ProfileMenu';

interface AppbarActionItemsProps {
  type?: 'default' | 'slim';
  sx?: SxProps;
  searchComponent?: ReactElement;
}

const AppbarActionItems = ({ type = 'default', sx, searchComponent }: AppbarActionItemsProps) => {
  return (
    <Stack
      className="action-items"
      spacing={1}
      sx={{
        alignItems: 'center',
        ml: 'auto',
        ...sx,
      }}
    >
      {searchComponent}
      <ProfileMenu type={type} />
    </Stack>
  );
};

export default AppbarActionItems;
